<template>
    <div class="vw-100 h-100 d-flex flex-row">
        <aside>
            <div class="header p-3 bg-light" style="z-index: 99">
                <a class="me-2 fs-3 text-dark cp btn-rounded btn-default btn d-block d-md-none" @click="toggle"><i class="mdi mdi-arrow-left"></i></a>
                <h5 class="m-0 px-2 py-2">Announcements</h5>
                <button class="btn btn-default btn-rounded" @click="$emitter.emit('show_announcement')" v-if="getRole === 'A'"><i class="mdi mdi-plus fs-20"></i></button>
            </div>
            <div class="flex-1 position-relative w-100 h-100 bg-light">
                <div class="position-absolute w-100 h-100 overflow-auto pb-3 px-3" v-if="announcements.length > 0 && !announcement_loading">
                    <div class="card mb-3 border-0 shadow-sm" v-for="(announcement, index) in announcements" :key="index">
                        <div class="card-body py-2 px-3">
                            <div class="card-title flex-column d-flex">
                                <span class="fs-13" v-html="announcement.message"></span>
                                <small class="my-3 fw-700 fs-10 opacity-8 text-uppercase">{{announcement.date_posted}}</small>
                                <button class="btn btn-default text-danger" @click="$emitter.emit('delete_modal_show', [deleteAnnouncement, index]);" v-if="getRole == 'A'" ><i class="mdi mdi-trash-can-outline fs-16"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="w-100 h-100 d-flex flex-column bg-white p-3 opacity-3" v-else-if="announcement_loading">
                    <div class="w-100 shimmer mb-3" style="height: 114px"></div>
                    <div class="w-100 shimmer mb-3" style="height: 114px"></div>
                    <div class="w-100 shimmer mb-3" style="height: 114px"></div>
                </div>
                <div class="w-100 h-100 d-flex flex-column align-items-center justify-content-center opacity-3" v-else>
                    <i class="mdi mdi-bell-off-outline h-auto" style="font-size: 100px;"></i>
                    <span class="fw-500">No announcements found</span>
                </div>
            </div>
        </aside>
        <div class="container align-items-center d-flex flex-column position-relative" style="background-color: var(--primary-color);">
            
            <button class="btn btn-secondary position-absolute d-block d-md-none" style="top: 10px; left:10px;z-index:20" @click="toggle">Announcements</button>

            <div class="text-center py-5" style="z-index:10">

                <img src="../../assets/versatech.png" style="max-width: 100%;" />

                <h1 class="text-white m-3 fw-600" style="font-size: 2.4em; letter-spacing: 1px;">Welcome to {{appname}}</h1>
                <h6 class="text-white-50">Logged in as {{getdata.name}}</h6>
                <!-- <div class="card card-body d-flex flex-row align-items-center justify-content-center profile-card">
                    <div class="avatar">
                        <img :src="getdata.image" style="border-radius: 50%; width: 3em; height: 3em">
                    </div>
                    <div class="d-flex flex-column ps-3 text-left">
                        <p class="m-0 fw-500 text-muted">LOGGED IN AS:</p>
                        <h3 class="m-0">{{getdata.name}}</h3>
                        <small>{{getdata.position}}</small>
                    </div>
                </div> -->
                <button class="btn btn-light my-2 fw-700 position-absolute" style="bottom: 10px; left: 10px;" @click="$emitter.emit('show_terms')">HRIS Data Privacy Consent</button>
            </div>
            <vue-particles color="#dedede" style="position: absolute; width: 100%; height: 100%;"></vue-particles>
        </div>

        <TermsModal />
        <AnnouncementModal />
    </div>
</template>

<script>
import TermsModal from '../modal/TermsModal';
import AnnouncementModal from '../modal/AnnouncementModal';

export default {
    components: {
        TermsModal,
        AnnouncementModal,
    },
    data() {
        return {
            announcements: [],
            announcement_loading: true,
            appname: process.env.VUE_APP_APPNAME,
        }
    },
    computed: {
        getdata() {
            let data = {};
            try {
                var json = JSON.parse(localStorage.getItem('versatechvex_data'));
                if(Object.keys(json).length) {
                    data = json;
                }
            }
            catch(e) {
                return {};
            }

            return data;
        },
        getRole() {
            try {
                var json = JSON.parse(localStorage.getItem('versatechvex_data'));
                if(json.role !== undefined) return json.role;
                else return 'U';
            }
            catch(e) {
                return 'U';
            }
        }
    },
    methods: {
        toggle() {
            let aside = document.getElementsByTagName('aside');
            if(aside[0] !== undefined) {
                if(aside[0].classList.contains('show')) aside[0].classList.remove('show');
                else aside[0].classList.add('show');
            }
        },
        async load() {
            this.announcement_loading = true;
            await this.$axios.get('/announcements')
                    .then((res) => {
                        this.announcements = res.data;
                    })
                    .catch((err) => {
                        this.$jlalert.show(err);
                    });
            this.announcement_loading = false;
        },
        async deleteAnnouncement(index) {
            await this.$axios.delete(`/announcements/${this.announcements[index].id}`)
                    .then((res) => {
                        this.$jlalert.show(res.data, (res.status !== 200));
                    })
                    .catch((err) => {
                        this.$jlalert.show(err);
                    });
            this.announcements.splice(index,1);
        }
    },
    mounted() {
        this.load();
        this.$emitter.on('load_announcement', () => {
            this.load();
        });
    }
}
</script>

<style scoped>

pre {
    display: block;
    font-family: 'Maven Pro' !important;
    margin: 0;
    padding: 0;
    font-size: 12px;
}

aside {
    width: 30vw;
    height: 100%;
    margin: 0 !important;
    padding: 0 !important;
    display: flex;
    flex-direction: column;
    transition: 0.3s ease;
}

.container {
    max-width: 100%;
}

.profile-card {
    width: 100%;
}

.header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.bg-primary {
    background-color: var(--sub-color) !important;
}

@media screen and (max-width: 767px) {
    aside {
        position: absolute;
        left: -100vw;
        width: 100vw;
        z-index: 999;
        background: #fff;
        height: calc(100vh - 98px) !important;
    }

    aside.show {
        left: 0;
    }

    .container {
        width: 100%;
        max-width: 100%;
    }
}
</style>